window.autosizeTextarea = function autosizeTextarea() {
  if (document.querySelector('textarea[data-autosize]')) {
    const autosizeTextareaElements = document.querySelectorAll(
      'textarea[data-autosize]'
    );
    autosizeTextareaElements.forEach((textarea) => {
      const startHeight = textarea.offsetHeight;
      textarea.addEventListener('input', autosize);
      function autosize() {
        const el = this;
        const newHeight = el.scrollHeight;
        if (newHeight > startHeight) {
          el.style.minHeight = `${el.scrollHeight}px`;
        } else {
          el.style.minHeight = startHeight;
        }
      }
    });
  }
};
autosizeTextarea();

window.outlinedBoxedInputsInit = function outlinedBoxedInputsInit() {
  const outlinedBoxedInputs = document.querySelectorAll('.meta-input.outlined-boxed-type');

  if (!outlinedBoxedInputs.length) return;

  outlinedBoxedInputs.forEach((outlinedBoxedInputEl) => {
    if (outlinedBoxedInputEl.classList.contains('is-outlined-focus-init')) return;

    outlinedBoxedInputEl.classList.add('is-outlined-focus-init');

    const input = outlinedBoxedInputEl.querySelector('input, textarea');
    if (!input) return;

    input.addEventListener('focus', () => {
      outlinedBoxedInputEl.classList.add('is-outlined-focused');
    });

    input.addEventListener('blur', () => {
      outlinedBoxedInputEl.classList.remove('is-outlined-focused');
    });

    if (input.tagName === 'TEXTAREA') {
      const label = outlinedBoxedInputEl.querySelector('label');

      if (label) {
        label.addEventListener('click', () => {
          input.focus();
        });
      }
    }
  });
};

outlinedBoxedInputsInit();
